import styled from "styled-components";

export const Container = styled.div`
    position: relative;

    width: 100%;
    height: auto;
    max-width: 64.875rem;
    
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    @media (max-width: 760px) {
        padding: 0 1rem 0;
    }
`;

export const Wrapper = styled.div`
    width: 100%;
    
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const CardNotification = styled.div`
    width: 100%;
    padding: 0.6rem;

    
    display: flex;
    cursor: pointer;
    align-items: center;
    border-radius: 1rem;
    justify-content: space-between;
    background-color: rgba(255, 82, 82, 0.08);
`;

export const ImageAndNotification = styled.div`
    display: flex;
    align-items: center;
`;

export const ContainerImage = styled.div`
    width: 3rem;
    height: 3rem;
    
    display: flex;
    align-items: center;
    justify-content: center;

    > img {
        width: 2rem;
    }
`;

export const Notification = styled.div`
    width: 100%;
    height: auto;

    gap: 1rem;
    display: flex;
    margin-left: 1rem;
    position: relative;
    align-items: center;
    justify-content: center;

    p {
        cursor: pointer;

        font-size: 0.75rem;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;    
    }

    span { 
        padding: 0.25rem 0.5rem;
        
        display: flex;

        border-radius: 999px;
        background-color: white;
        text-align: center;
        text-transform: uppercase;
    }

    span p {
        white-space: nowrap;

        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    @media (max-width: 1050px) {
        flex-direction: column;
    }
`;

export const ButtonLocalization = styled.button`
    all: unset;
    padding: 0.5rem;
    
    display: flex;
    align-items: center;
    
    border-radius: 10rem;
    background-color: #FFFFFF;
`;

export const PrevButton = styled.button`
    all: unset;

    width: 3rem;
    height: 3rem;

    display: flex;
    align-items: center;
    justify-content: center; 
    
    border: none;
    cursor: pointer;
    font-size: 1.5rem;
    border-radius: 50%;
    /* transform: translateY(-50%); */

    @media (max-width: 1050px) {
        top: 58%;
    }
`;

export const NextButton = styled.button`
    all: unset;

    width: 3rem;
    height: 3rem;

    display: flex;
    align-items: center;
    justify-content: center; 
    
    border: none;
    cursor: pointer;
    font-size: 1.5rem;
    border-radius: 50%;
    transform: rotate(180deg);
`;
